export default __webpack_public_path__ + "static/media/cancelled_Orders.e184e8e2.svg";